module.exports = __webpack_public_path__ + "static/media/extended-background@3x.5bcb651b.png";